<div class="card bg-transparent border rounded-5 shadow-sm d-flex flex-column border-bottom
            flex-grow-1 h-100"
  v-if="token_exists"
>
  <!-- Header -->
  <div class="card bg-transparent border-0">
    <h6 class="card-header text-muted bg-transparent">Upcoming Birthdays</h6>
  </div>
 
  <!-- Body -->
  <div class="card-body pt-0">
    <!-- Empty state -->
    <div v-if="upcoming_birthdays.length === 0" class="text-center">
      <p class="text-muted text-xs fst-italic mb-0">No upcoming birthdays</p>
    </div>
 
    <!-- List -->
    <ul v-else class="list-group list-group-flush border-0">
      <li
        v-for="(profile, index) in (showAll ? upcoming_birthdays : upcoming_birthdays.slice(0, 3))"
        :key="profile.id"
        class="list-group-item border-0 bg-transparent"
      >
        <div class="d-flex align-items-center gap-3">
          <div v-if="get_profile_picture(profile)"
              class="me-2 avatar-xxl rounded-circle border border-2 border-white me-2 profile-list-avatar pointer">
            <img
              :src="get_profile_picture(profile)"
              :alt="get_profile_name(profile)"
              class="w-100 h-100 rounded-circle object-fit-cover"
            >
          </div>
            <div v-else class="me-2 avatar-xxl rounded-circle border border-2 border-white me-2 profile-list-avatar pointer">
              <i class="bi bi-person-circle fs-3 text-dark pointer"></i>
            </div>

          <div class="flex-grow-1">
            <div class="fw-500 small mb-0">
              {{ get_profile_name(profile) }}
            </div>
            <div class="text-muted text-xxs">
              {{ formatDate(profile.date_of_birth) }}
            </div>
          </div>
        </div>
      </li>
    </ul>
 
    <!-- See more / less -->
    <div v-if="upcoming_birthdays.length > 3" class="text-center mt-3">
      <a
        class="text-decoration-none fs-italic text-xxs"
        @click.prevent="toggleShowMore"
      >
        {{ showAll ? 'Show less' : `See more (${upcoming_birthdays.length - 3} more)` }}
    </a>
    </div>
  </div>
</div>
 
